export default __webpack_public_path__ + "static/media/icon__child.012ff036.svg";